import { ACSApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { dispatch } from '../../../store';
import { setTimeLogsByProjectWithLeaveRequests } from '../../../store/slices/time-tracking.slice';
import { useState } from 'react';

const useHttpGetTimeLogsByInterval = () => {
    const acsApi: ACSApi = useContainer(ACSApi);
    const [isReady, setIsReady] = useState(false);

    const getLogs = (from: string, to: string, userSub?: string) => {
        const { exec, abort } = acsApi.getTimeLogsByInterval({
            query: { from: encodeURIComponent(from), to: encodeURIComponent(to), userSub },
            onSuccess: res => {
                dispatch(setTimeLogsByProjectWithLeaveRequests(res.body));
                setIsReady(true);
            },
            onError: error => error,
        });

        exec();
        return abort;
    };

    return { getLogs, isReady };
};

export default useHttpGetTimeLogsByInterval;
